import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=328581bd"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports